import mainCaller from '../mainCaller';

// export async function getUsersList(token, body) {
//   const { data } = await mainCaller(`user/multiSearch/list`, 'POST', body, {
//     Authorization: `Bearer ${token}`,
//   });
//   return data;
// }

export async function updatePaymentPermission(token, id) {
  return await mainCaller(`admin/api/v1/center/managers/${id}/payment-permission`, 'PATCH', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function createCenters(token, body) {
  const { data } = await mainCaller(`admin/api/v1/centers`, 'POST', body, {
    Authorization: `Bearer ${token}`,
  });
  return data;
}

export async function getAllCentersList(token, query) {
  return await mainCaller(`admin/api/v1/centers?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}
export async function centersDetail(token, id) {
  return await mainCaller(`admin/api/v1/centers/${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function updateCenter(token, id, data) {
  return await mainCaller(`admin/api/v1/centers/${id}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
}

export async function createPointIntro(data, token) {
  return await mainCaller(`admin/api/v1/branches`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}
